/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Styles_Solid_Background_OptionInputs */



/**
* | output |
* | --- |
* | "Solid Background" |
*
* @param {Styles_Solid_Background_OptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const styles_solid_background_option = /** @type {((inputs?: Styles_Solid_Background_OptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Styles_Solid_Background_OptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Fond solide")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einfarbiger Hintergrund")
	if (locale === "it") return /** @type {LocalizedString} */ ("Solido background")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сплошной фон")
	if (locale === "es") return /** @type {LocalizedString} */ ("Fondo sólido")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("纯色背景")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ソリッド背景")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ठोस पृष्ठभूमि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fundo sólido")
	return /** @type {LocalizedString} */ ("Solid Background")
});